import { makeStyles, Typography } from "@material-ui/core";
import React from "react";
import {
  tabletMinWidth,
  desktopMinWidth,
  maxContentWidth
} from "./helpers/constants";

const useStyles = makeStyles((theme) => ({
  header: {
    backgroundColor: theme.palette.white.main,
    textAlign: "center",
    padding: `${theme.spacing(4)}px ${theme.spacing(4)}px ${theme.spacing(
      8
    )}px`,
    "& .headertext": {
      textAlign: "center",
      width: "100%",
      "& sup": {
        fontSize: "75%",
        verticalAlign: "baseline",
        position: "relative",
        lineHeight: 0,
        top: "-0.5em"
      }
    },
    "& .wrapper": {
      flexDirection: "column"
    },
    "& .heroimage": {
      "& img": {
        maxWidth: "100%",
        height: "auto"
      }
    }
  },
  title: {
    ...theme.typography.xsH1,
    paddingBottom: `${4}px`,
    color: theme.palette.secondary.main
  },
  title2: {
    fontSize: "18px",
    color: "#86939A",
    display: "block"
  },
  preheader: {
    paddingBottom: `${2}px`,
    ...theme.typography.overline,
    color: theme.palette.primary.light
  },
  subtitle: {
    paddingBottom: `${2}px`,
    ...theme.typography.subtitle1,
    color: theme.palette.primary.light
  },
  [`@media only screen and (min-width: ${tabletMinWidth}px)`]: {
    header: {
      "& .wrapper": {
        maxWidth: `${maxContentWidth}px`,
        marginLeft: "auto",
        marginRight: "auto",
        display: "flex",
        flexDirection: "row-reverse"
      },
      padding: `${theme.spacing(7)}px ${theme.spacing(7)}px ${theme.spacing(
        8
      )}px`,
      "& .heroimage": {
        width: "50%",
        "& img": {
          maxWidth: "100%",
          height: "auto"
        },
        margin: "0px 0px 10px 0px"
      },
      "& .headertext": {
        textAlign: "left",
        width: "50%"
      }
    },
    title: {
      ...theme.typography.h1
    },
    title2: {
      fontSize: "18px",
      color: "#86939A",
      display: "block"
    }
  },
  [`@media only screen and (min-width: ${desktopMinWidth}px)`]: {
    title: {
      ...theme.typography.lgH1
    },
    title2: {
      display: "inline"
    },
    preheader: {
      ...theme.typography.lgOverline
    },
    subtitle: {
      ...theme.typography.lgSubtitle1
    },
    body: {
      ...theme.typography.lgBody1
    }
  }
}));

function HeroSection({
  photo_url,
  overline,
  title,
  subtitle,
  description,
  title2
}) {
  const classes = useStyles();
  return (
    <header className={classes.header}>
      <div className={"wrapper"}>
        <div className={"heroimage"}>
          <img src={photo_url} alt="" />
        </div>
        <div className={"headertext"}>
          <Typography className={classes.preheader}>{overline}</Typography>
          <Typography className={classes.title}>
            {title}
            <Typography
              variant="subtitle2"
              component={"span"}
              display={"inline"}
              className={classes.title2}
            >
              {title2}
            </Typography>
          </Typography>
          <Typography
            className={classes.subtitle}
            dangerouslySetInnerHTML={{ __html: subtitle }}
          />
          <Typography
            className={classes.body}
            dangerouslySetInnerHTML={{ __html: description }}
          ></Typography>
        </div>
      </div>
    </header>
  );
}

export default HeroSection;
